/* Keep the next application section visible beneath the shared sticky header. */
(() => {
  const initialised = new WeakSet();
  const initialise = (scope) => {
    const roots = [...scope.querySelectorAll('body.site-refresh .team59-page')];
    if (scope.matches?.('body.site-refresh .team59-page')) roots.unshift(scope);

    roots.forEach((root) => {
      if (initialised.has(root)) return;
      initialised.add(root);
      let pendingFrame = 0;
      const visibleStep = () => root.querySelector('[data-team59-step]:not([hidden])');

      const followChangedStep = () => {
        const previous = visibleStep();
        cancelAnimationFrame(pendingFrame);
        pendingFrame = requestAnimationFrame(() => {
          const current = visibleStep();
          // A validation error or clicking the current step must not move the page.
          if (!current || current === previous) return;
          const target = root.querySelector(window.matchMedia('(max-width:760px)').matches
            ? '.team59-application-grid' : '.team59-form__questions') || current;
          let headerOffset = 0;
          document.querySelectorAll('.site-header,.ref-header').forEach((header) => {
            const styles = getComputedStyle(header);
            if (styles.position !== 'sticky' && styles.position !== 'fixed') return;
            headerOffset = Math.max(headerOffset, header.getBoundingClientRect().height + (parseFloat(styles.top) || 0));
          });
          const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset - 18);
          const reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
          window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      };

      root.addEventListener('click', (event) => {
        if (event.target instanceof Element && event.target.closest('[data-team59-next],[data-team59-back],[data-team59-goto]')) {
          followChangedStep();
        }
      }, true);
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.isComposing && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey && event.target instanceof HTMLInputElement) {
          followChangedStep();
        }
      }, true);
      root.addEventListener('submit', followChangedStep, true);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once:true });
  else initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
